import { render, staticRenderFns } from "./ContentTypeFieldsList.vue?vue&type=template&id=5d58ae2d&scoped=true"
import script from "./ContentTypeFieldsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentTypeFieldsList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContentTypeFieldsList.vue?vue&type=style&index=0&id=5d58ae2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d58ae2d",
  null
  
)

export default component.exports